export default __webpack_public_path__ + "static/media/Pure.827a6d99.jpg";